import { render, staticRenderFns } from "./ObjectivesEditor.vue?vue&type=template&id=8be9d598&scoped=true&"
import script from "./ObjectivesEditor.vue?vue&type=script&lang=js&"
export * from "./ObjectivesEditor.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivesEditor.vue?vue&type=style&index=0&id=8be9d598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be9d598",
  null
  
)

export default component.exports